<template>
  <nav class="portal-nav">
    <div class="page-shell portal-nav__row">
      <button class="portal-nav__toggle" type="button" @click="mobileOpen = !mobileOpen" aria-label="Toggle navigation">
        <span></span>
        <span></span>
        <span></span>
      </button>

      <div class="portal-nav__links" :class="{ 'is-open': mobileOpen }">
        <router-link v-if="!isAuthenticated" to="/login" class="portal-nav__link" @click="mobileOpen = false">Вход</router-link>
        <router-link v-if="!isAuthenticated" to="/register" class="portal-nav__link" @click="mobileOpen = false">Первичная настройка</router-link>

        <router-link
          v-for="item in isAuthenticated ? navItems : []"
          :key="typeof item.to === 'string' ? item.to : `${item.label}-${item.to.path}`"
          :to="item.to"
          class="portal-nav__link"
          @click="mobileOpen = false"
        >
          {{ item.label }}
        </router-link>
      </div>

      <div v-if="isAuthenticated" class="portal-nav__user">
        <details class="portal-user-menu">
          <summary>
            <span class="portal-user-menu__name">{{ username }}</span>
            <span class="portal-user-menu__role">{{ userRole }}</span>
          </summary>
          <div class="portal-user-menu__panel">
            <div class="small text-muted mb-2">Учетная запись</div>
            <div class="portal-user-menu__identity">{{ username }} / {{ userRole }}</div>
            <button type="button" class="btn btn-sm btn-outline-secondary w-100 mt-3" @click="handleLogout">Выход</button>
          </div>
        </details>
      </div>
    </div>
  </nav>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { navItemsForRole } from '../utils/navigation';

export default {
  data() {
    return {
      mobileOpen: false,
    };
  },
  computed: {
    ...mapGetters('auth', ['isAuthenticated', 'username', 'userRole']),
    navItems() {
      return navItemsForRole(this.userRole);
    }
  },
  watch: {
    $route() {
      this.mobileOpen = false;
    }
  },
  methods: {
    ...mapActions('auth', ['logout']),
    handleLogout() {
      this.logout();
      if (this.$syncSocketAuth) this.$syncSocketAuth();
      if (this.$socket) this.$socket.disconnect();
      this.$router.push('/login');
    }
  }
};
</script>

<style scoped>
.portal-nav {
  border-top: 1px solid #d7e3ef;
  border-bottom: 1px solid #d7e3ef;
  background: #edf4fb;
}

.portal-nav__row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  min-height: 56px;
}

.portal-nav__links {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
}

.portal-nav__link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 36px;
  padding: 0 12px;
  border-radius: 6px;
  text-decoration: none;
  color: var(--app-text-soft);
  font-weight: 500;
}

.portal-nav__link:hover,
.router-link-active.portal-nav__link {
  color: #0f4c81;
  background: #dbeaf8;
}

.portal-nav__toggle {
  display: none;
  width: 46px;
  height: 46px;
  border: 1px solid rgba(148, 163, 184, 0.16);
  border-radius: 6px;
  background: #ffffff;
  padding: 10px;
  flex-direction: column;
  justify-content: center;
  gap: 5px;
}

.portal-nav__toggle span {
  display: block;
  width: 100%;
  height: 2px;
  border-radius: 999px;
  background: var(--app-text);
}

.portal-nav__user {
  display: flex;
  align-items: center;
}

.portal-user-menu {
  position: relative;
}

.portal-user-menu summary {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  cursor: pointer;
  list-style: none;
  padding: 8px 12px;
  border-radius: 6px;
  border: 1px solid #d3deeb;
  background: #ffffff;
}

.portal-user-menu summary::-webkit-details-marker {
  display: none;
}

.portal-user-menu__name {
  font-weight: 700;
}

.portal-user-menu__role {
  color: var(--app-text-muted);
  font-size: 0.78rem;
  text-transform: uppercase;
  letter-spacing: 0.08em;
}

.portal-user-menu__panel {
  position: absolute;
  right: 0;
  top: calc(100% + 10px);
  min-width: 240px;
  padding: 16px;
  border-radius: 8px;
  border: 1px solid #d3deeb;
  background: #ffffff;
  box-shadow: var(--app-shadow);
}

.portal-user-menu__identity {
  font-weight: 600;
}

@media (max-width: 900px) {
  .portal-nav__row {
    min-height: auto;
    padding: 12px 0;
    align-items: flex-start;
    flex-wrap: wrap;
  }

  .portal-nav__toggle {
    display: inline-flex;
  }

  .portal-nav__links {
    display: none;
    width: 100%;
    flex-direction: column;
    align-items: stretch;
    padding-bottom: 4px;
  }

  .portal-nav__links.is-open {
    display: flex;
  }

  .portal-nav__link {
    justify-content: flex-start;
  }

  .portal-nav__user {
    margin-left: auto;
  }
}

@media (max-width: 600px) {
  .portal-nav__user {
    width: 100%;
  }

  .portal-user-menu,
  .portal-user-menu summary,
  .portal-user-menu__panel {
    width: 100%;
  }

  .portal-user-menu summary {
    align-items: flex-start;
  }

  .portal-user-menu__panel {
    position: static;
    margin-top: 10px;
  }
}
</style>
